import React from 'react';
import { Typography, Box, Avatar } from '@mui/material';
import { useSession } from '../context/SessionContext';

const UserProfile = () => {
  const { participant } = useSession();

  if (!participant) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
      <Avatar sx={{ mr: 2, bgcolor: participant.color || 'primary.main' }}>
        {participant.name && typeof participant.name === 'string' ? participant.name.charAt(0).toUpperCase() : 'P'}
      </Avatar>
      <Typography variant="subtitle1">
        {participant.name || 'Waiting for name...'} ({participant.role || 'N/A'})
      </Typography>
    </Box>
  );
};

export default UserProfile; 